import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCA7eVYfhGWR_-SQg5LHjeo2QVluHv_rPg",
  authDomain: "dojo-acil-yardim.firebaseapp.com",
  projectId: "dojo-acil-yardim",
  storageBucket: "dojo-acil-yardim.appspot.com",
  messagingSenderId: "80900522200",
  appId: "1:80900522200:web:143ff0e58e6a6c2b1457ad",
  measurementId: "G-39W1HZ0WFF",
};

// init firebase
firebase.initializeApp(firebaseConfig);

// init services
const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();
const projectStorage = firebase.storage();

// timestamp
const timestamp = firebase.firestore.Timestamp;

export { projectFirestore, projectAuth, timestamp, projectStorage };
